import {
  GlobeCheck,
  globeCoin,
  KeyBoard,
  StockRaise,
} from "./../../Public/assets";
import React, { useEffect, useState } from "react";

function StableReturn() {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Content for each slide
  const slides = [
    {
      title: "Generate Stable Returns",
      description:
        "Earn consistent yields and protect your wealth with our fixed income products. Enjoy predictable growth and confidence, even in uncertain markets.",
      image: StockRaise,
      bgColor: "bg-white",
    },
    {
      title: "Maximize Your Investments",
      description:
        "Strategic investment solutions tailored to your financial goals. Our expert team helps you navigate market complexities.",
      image: GlobeCheck,
      bgColor: "bg-white",
    },
    {
      title: "Smart Portfolio Management",
      description:
        "Diversify your portfolio with our data-driven approach. We help you make informed decisions for long-term growth.",
      image: globeCoin,
      bgColor: "bg-white",
    },
    {
      title: "Global Market Insights",
      description:
        "Stay ahead with our comprehensive market analysis and international investment opportunities.",
      image: KeyBoard,
      bgColor: "bg-white",
    },
  ];

  // Auto-advance slides every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  // Handle manual navigation
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };
  const getCircularIndex = (index, length) => {
    return ((index % length) + length) % length;
  };
  const getCurrentImages = () => {
    return [
      slides[getCircularIndex(currentSlide, slides.length)].image,
      slides[getCircularIndex(currentSlide + 1, slides.length)].image,
      slides[getCircularIndex(currentSlide + 2, slides.length)].image,
    ];
  };

  const currentImages = getCurrentImages();

  return (
    <div
      className={` md:min-h-[580px] transition-colors duration-500 ${slides[currentSlide].bgColor}`}
    >
      <div className="hidden md:block container mx-auto px-4 py-12">
        <div className="flex flex-col lg:flex-row items-center gap-8">
          {/* Text Content */}
          <div className="lg:w-1/2 space-y-1 ml-[41px]">
            <h1 className="font-IvyJournal  text-blueish font-[600] text-[42px] leading-[54px] transition-all duration-500">
              {slides[currentSlide].title}
            </h1>
            <p className="font-geomanistRegular font-[400] text-greyish text-[16px] leading-[21px] w-3/4 transition-all duration-500">
              {slides[currentSlide].description}
            </p>
          </div>

          {/* Image Carousel */}
          <div className="lg:w-1/2 relative">
            <div className="relative overflow-hidden">
              <div className="flex items-end gap-[25px]">
                {currentImages.map((image, index) => (
                  <img
                    key={`${currentSlide}-${index}`}
                    src={image}
                    alt={`Slide ${index + 1}`}
                    className={`object-cover w-[332px] rounded-2xl transition-opacity duration-500 ${
                      index === 0 ? "h-[423px]" : "h-[323px] opacity-60"
                    }`}
                  />
                ))}
              </div>
            </div>

            {/* Navigation Dots */}
            <div className="flex  ml-8 mt-4 space-x-2">
              {slides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    currentSlide === index ? "bg-blue-600 w-6" : "bg-blue-200"
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="md:hidden  mx-auto px-6 py-12">
        <div className="flex flex-col lg:flex-row items-center gap-8">
          {/* Image Carousel */}
          <div className="lg:w-1/2 relative">
            <div className="relative overflow-hidden">
              <div className="flex items-end gap-[25px]">
                {currentImages.map((image, index) => (
                  <img
                    key={`${currentSlide}-${index}`}
                    src={image}
                    alt={`Slide ${index + 1}`}
                    className={`object-cover w-[182px] rounded-2xl transition-opacity duration-500 ${
                      index === 0 ? "h-[223px]" : "h-[182px] opacity-60"
                    }`}
                  />
                ))}
              </div>
            </div>

            {/* Text Content */}
            <div className="space-y-1  text-center">
              <h1 className="font-IvyJournal  text-blueish font-[600] text-[22px] md:text-[42px] mt-[21px] md:leading-[54px] transition-all duration-500">
                {slides[currentSlide].title}
              </h1>
              <p className="font-geomanistRegular font-[400] text-greyish text-[16px] leading-[21px] transition-all duration-500">
                {slides[currentSlide].description}
              </p>
            </div>

            {/* Navigation Dots */}
            <div className="flex justify-center mt-4 space-x-2">
              {slides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    currentSlide === index ? "bg-blue-600 w-6" : "bg-blue-200"
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StableReturn;
